export const QUERYSHEET_TEMPLATE_FILE_FORMATS = '.xlsx';
export const QUERYSHEET_TEMPLATE_FILE_NAME = 'Query Sheet Template';
export const QUERYSHEET_STATUS_PENDING= 'pending';
export const QUERYSHEET_STATUS_PROCESSING = 'processing';
export const QUERYSHEET_STATUS_SUCCESS = 'success';
export const QUERYSHEET_STATUS_FAILED = 'failed';
